<template>
  <div>
    <div class="mrB20" />
    <ur-data-grid
      ref="gridLinkParam"
      :headers="columnLinkParam"
      :options="LinkParamOptions"
      :data-source="dsLinkParam"
    />
    <!-- <sui-s-grid
      ref="gridLinkParam"
      :headers="columnLinkParam"
      :options="LinkParamOptions"
      :data-source="dsLinkParam"
    /> -->
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="contextPageId"
        type="button"
        class="comm_btn_solid"
        :disabled="checkMetaSave"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import {urDataSet} from 'uidev-component/index.js';
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;

export default {
  name: 'PGE_CMP_00027_T02', // eslint-disable-line vue/name-property-casing
  components:{
    urDataGrid,
  },
  extends: BasePage,
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dsLinkParam: new urDataSet(),
      LinkParamOptions: {
        rowEdit: true,
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
        // noInfo: true,
        // cellEdit: true,
        // keepEditable: true,
      },
      checkMetaSave: utils.checkMetaSave(),
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (selectObj) {
        this.linkParamListLoad();
      } else {
        this.tapGridClear();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.linkParamListLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  created() {
    this.columnLinkParam = [
      {
        value: 'linkParameterName',
        text: this.$t('MSG_TXT_PRMT_NM'),
        key: true,
        rules: undefined,
      },
      {
        value: 'linkParameterValue',
        text: this.$t('MSG_TXT_PRMT_VAL'),  
        rules: undefined,
      },
    ];
  },
  methods: {
    linkParamListLoad() {
      if (this.selectedGridRowData) {
        const linkId = this.selectedGridRowData.linkId;
        http.request(this.contextPageId, 'DTS_CMP_00114', {
          path: {
            'link-id': linkId,
          },
        }).then(res => {
          this.dsLinkParam.setData(res.data);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    tapGridClear() {
      this.$refs.gridLinkParam.gridLinkParam();
    },
    onSaveClick() {
      if (utils.isEmpty(this.selectedGridRowData.linkId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_LINK')));
      } else {
        // save
        const saveData = this.dsLinkParam.getRawData();
        utils.forEach(saveData, item => {
          item.linkId = this.selectedGridRowData.linkId;
        });

        const validResult = this.validation(saveData);
        if (validResult.valid) {
          this.saveAction(saveData);
        } else {
          utils.messageBox('warning', validResult.msg, null, () => {});
        }
      }
    },
    validation(saveData) {
      const result = {
        valid: true,
        msg: '',
        row: 0,
        column: '',
      };
      utils.forEach(saveData, (data, index) => {
        if (utils.isEmpty(data.linkParameterName)) {
          result.valid = false;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), index + 1, this.$t('MSG_TXT_PRMT_NM'));
          result.row = index;
          result.column = 'linkParameterName';
          return false;
        }
        if (utils.isEmpty(data.linkParameterValue)) {
          result.valid = false;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), index + 1, this.$t('MSG_TXT_PRMT_VAL'));
          result.row = index;
          result.column = 'linkParameterValue';
          return false;
        }
        return true;
      });
      return result;
    },
    saveAction(saveData) {
      const linkId = this.selectedGridRowData.linkId;
      http.request(this.contextPageId, 'DTS_CMP_00115', {
        path: {
          'link-id': linkId,
        },
        data: saveData,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
        this.dsLinkParam.setData('');
        this.linkParamListLoad();
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
